import React from "react";
import AuditTrail from "../../../components/AuditTrail";
import { ApiURL } from "../../../services/apiConstants";

export default function AuditPage() {
  return <AuditTrail endpoint={ApiURL.bunker_audit_logs_st} />;
}
